import { useState } from "react";
import React from "react";
import {
  Button,
  TextField,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";

const vendors = [
  "#ST001 - Downtown Store",
  "#ST002 - City Mall Store",
  "#ST003 - Central Plaza",
];

const AddDiscount = () => {
  // Dropdown for Discount Type
  const [type, setType] = useState("default");

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  // Usage Limit (Your error fix)
  const [usageLimit, setUsageLimit] = useState("");

  // Store Select

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Add Discount and Coupon</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/discounts")}>
            Discounts and Coupons
          </button>{" "}
          - Add Discount and Coupon
        </p>
      </div>

      <div className="cards custom_form_details">
        <div className="form">
          <div className="gap_m w_100">
            {/* Discount Name */}
            <div className="control_group w_50">
              <label htmlFor="offer_name">Offer/Discount Name</label>
              <TextField
                id="offer_name"
                placeholder="Enter Discount Name"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Coupon Code */}
            <div className="control_group w_50">
              <label htmlFor="coupon_code">Coupon Code</label>
              <TextField
                disabled
                id="coupon_code"
                placeholder="Will be auto-generated"
                fullWidth
                hiddenLabel
              />
            </div>        
            {/* Discount Type */}
            <div className="control_group w_25">
              <label>Discount Type</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Discount Type
                </MenuItem>
                <MenuItem value="percentage">Percentage (%)</MenuItem>
                <MenuItem value="flat">Flat (₹)</MenuItem>
                <MenuItem value="both">Both (XX% off up to ₹YY)</MenuItem>
              </Select>
            </div>

            {/* Discount Percentage */}
            <div className="control_group w_25">
              <label>Discount (%)</label>
              <TextField
                placeholder="Enter Discount (%)"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Flat Amount */}
            <div className="control_group w_50">
              <label>Flat Amount (₹)</label>
              <TextField
                placeholder="Enter Flat Amount"
                fullWidth
                hiddenLabel
              />
            </div>

            {/* Time Slot */}
            <div className="control_group w_50">
              <label>Applicable Time Slot</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Time Slot
                </MenuItem>
                <MenuItem value="morning">Morning (8 AM - 12 PM)</MenuItem>
                <MenuItem value="afternoon1">Afternoon (12 PM - 4 PM)</MenuItem>
                <MenuItem value="evening">Evening (4 PM - 8 PM)</MenuItem>
              </Select>
            </div>

            {/* Valid Date */}
            <div className="control_group w_50">
              <label>Valid From - To</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/date_icon.svg" alt="Pick date" />
                    ),
                  }}
                  slotProps={{
                    textField: {
                      placeholder: "Select Date",
                      fullWidth: true,
                      hiddenLabel: true,
                    },
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>

            {/* Usage Limit */}
            <div className="control_group w_50">
              <label>Usage Limit*</label>
              <TextField
                type="number"
                placeholder="e.g., 10"
                fullWidth
                value={usageLimit}
                onChange={(e) => setUsageLimit(e.target.value)}
              />
            </div>
              <div className="control_group w_50">
              <label>Eligible Users</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Discount Type
                </MenuItem>
                <MenuItem value="percentage">All Users</MenuItem>
                <MenuItem value="flat">New Users Only</MenuItem>
                <MenuItem value="both">Existing Subscribers</MenuItem>
              </Select>
            </div>
           

          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="form_btn">
        <Button className="btn btn_primary" variant="contained">
          Save
        </Button>
      </div>
    </>
  );
};

export default AddDiscount;
